(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaSnomed', RcopiaSnomed);

    RcopiaSnomed.$inject = ['$resource'];

    function RcopiaSnomed ($resource) {
        var resourceUrl =  'api/rcopia-snomeds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
